// paxsudos/frontend/status_action_bar.jsx
// Lisää “💬 Laajenna julkaisu” -nappi vastausnapin viereen DOM-injektiona.

const LABEL = 'Laajenna julkaisu';
const BTN_FLAG = 'paxsudosExpandInjected';

// Etsi palkit
function findBars(scope) {
  const root = scope || document;
  return Array.from(root.querySelectorAll('.status__action-bar'));
}

// Permalink/fallback – avaa julkaisun ketju
function openStatusFromBar(bar) {
  const status = bar.closest('.status') || bar.parentElement || document;
  const timeLink =
    status.querySelector('.status__relative-time a, a.status__relative-time') ||
    status.querySelector('a[href*="/@"][href*="/status/"]') ||
    status.querySelector('a[href*="/status/"]');
  if (timeLink && timeLink.href) window.location.href = timeLink.href;
}

// Luo nappi (emoji “puhekupla”)
function makeButton(onClick) {
  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'status__action-bar-button icon-button';
  btn.title = LABEL;
  btn.setAttribute('aria-label', LABEL);

  const icon = document.createElement('span');
  icon.className = 'icon';
  icon.textContent = '💬';

  btn.appendChild(icon);
  btn.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    onClick();
  });
  return btn;
}

// Injektoi reply-napin jälkeen, kerran per palkki
function injectIntoBar(bar) {
  if (!bar || bar.dataset[BTN_FLAG] === '1') return;

  const group = bar.querySelector('.status__action-bar-group') || bar;
  const replyBtn = group.querySelector('.status__action-bar-button'); // yleensä eka = Vastaa
  const btn = makeButton(() => openStatusFromBar(bar));

  if (replyBtn && replyBtn.parentNode === group) {
    replyBtn.after(btn);
  } else {
    group.appendChild(btn);
  }

  bar.dataset[BTN_FLAG] = '1';
}

// Skannaa ja injektoi kaikkiin palkkeihin
function scan() {
  findBars().forEach(injectIntoBar);
}

// Turvallinen boot: odota DOMia, tarkista root ja aseta MO
(function boot() {
  if (window.__PAX_EXPAND_BTN_OBS) return; // mount vain kerran

  const start = () => {
    scan();

    const root = document.body || document.documentElement;
    if (!root) {
      // jos vieläkin puuttuu, yritä pian uudelleen
      setTimeout(start, 50);
      return;
    }

    const mo = new MutationObserver(() => scan());
    try {
      mo.observe(root, { childList: true, subtree: true });
      window.__PAX_EXPAND_BTN_OBS = mo;
    } catch (e) {
      // varmistus vanhoille selaimille / harvinaisille tilanteille
      setTimeout(start, 50);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
